import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text, Box } from "@similarweb/ui-components/foundations";

import {
    BaseWidget,
    WidgetMainText,
} from "app/pages/digital-marketing/monitor-and-protect/shared/components/widgets/base-widget";
import { IndicatorBadge } from "app/pages/digital-marketing/common/ui/IndicatorBadge/IndicatorBadge";
import { InsightHeader } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/typography/texts";
import { useTranslation } from "pro-features/components/WithTranslation";

export const MetricsSection = () => {
    const translate = useTranslation();
    return (
        <Stack
            paddingX="40px"
            gap="32px"
        >
            <Box
                position="relative"
                height="160px"
                width="200px"
            >
                <BaseWidget
                    position="absolute"
                    flexDirection="column"
                    justifyContent="space-around"
                    width="142px"
                    padding="12px"
                    height="86px"
                >
                    <WidgetMainText
                        color={colorsPalettes.carbon["400"]}
                        fontVariant="primaryItem"
                    >
                        {translate("monitor_and_protect.homepage.metrics.clicks")}
                    </WidgetMainText>
                    <Flex gap="8px">
                        <Text
                            as="h4"
                            fontVariant="h5"
                            color={colorsPalettes.carbon["500"]}
                        >
                            860K
                        </Text>
                        <IndicatorBadge value={5} />
                    </Flex>
                </BaseWidget>
                <BaseWidget
                    delay="50ms"
                    position="absolute"
                    flexDirection="column"
                    justifyContent="space-around"
                    width="142px"
                    padding="12px"
                    height="86px"
                    top="64px"
                    right="0"
                >
                    <WidgetMainText
                        fontVariant="primaryItem"
                        color={colorsPalettes.carbon["400"]}
                    >
                        {translate("monitor_and_protect.homepage.metrics.lost_click")}
                    </WidgetMainText>
                    <Flex gap="8px">
                        <Text
                            as="h4"
                            fontVariant="h5"
                            color={colorsPalettes.carbon["500"]}
                        >
                            17%
                        </Text>
                        <IndicatorBadge value={-2} />
                    </Flex>
                </BaseWidget>
            </Box>

            <InsightHeader
                fontVariant="h6"
                delay="100ms"
                color={colorsPalettes.carbon["400"]}
            >
                {translate("monitor_and_protect.homepage.metrics.insight")}
            </InsightHeader>
        </Stack>
    );
};
